var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribePhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9826_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9167 34.5H21.3125C22.371 34.5 23.2292 35.3954 23.2292 36.5V39C23.2292 40.1046 22.371 41 21.3125 41H18.9167C17.8581 41 17 40.1046 17 39V36.5C17 35.3955 17.8581 34.5 18.9167 34.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1535 34.842C38.8373 34.6185 38.464 34.4993 38.082 34.5H35.6862C34.6277 34.5 33.7695 35.3954 33.7695 36.5V39C33.7695 40.1046 34.6277 41 35.6862 41H38.082C39.1406 41 39.9987 40.1046 39.9987 39V36.5C39.9986 35.8351 39.6818 35.2137 39.1535 34.842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9167 25.75H21.3125C22.371 25.75 23.2292 26.6455 23.2292 27.75V30.25C23.2292 31.3546 22.371 32.25 21.3125 32.25H18.9167C17.8581 32.25 17 31.3546 17 30.25V27.75C17 26.6454 17.8581 25.75 18.9167 25.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1535 26.092C38.8373 25.8685 38.464 25.7493 38.082 25.75H35.6862C34.6277 25.75 33.7695 26.6455 33.7695 27.75V30.25C33.7695 31.3546 34.6277 32.25 35.6862 32.25H38.082C39.1406 32.25 39.9987 31.3546 39.9987 30.25V27.75C39.9986 27.085 39.6818 26.4637 39.1535 26.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9167 17H21.3125C22.371 17 23.2292 17.8955 23.2292 19V21.5C23.2292 22.6046 22.371 23.5 21.3125 23.5H18.9167C17.8581 23.5 17 22.6046 17 21.5V19C17 17.8955 17.8581 17 18.9167 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7707 34.842C30.4544 34.6185 30.0811 34.4993 29.6992 34.5H27.3034C26.2449 34.5 25.3867 35.3954 25.3867 36.5V39C25.3867 40.1046 26.2449 41 27.3034 41H29.6992C30.7578 41 31.6159 40.1046 31.6159 39V36.5C31.6158 35.8351 31.299 35.2137 30.7707 34.842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7707 26.092C30.4544 25.8685 30.0811 25.7493 29.6992 25.75H27.3034C26.2449 25.75 25.3867 26.6455 25.3867 27.75V30.25C25.3867 31.3546 26.2449 32.25 27.3034 32.25H29.6992C30.7578 32.25 31.6159 31.3546 31.6159 30.25V27.75C31.6158 27.085 31.299 26.4637 30.7707 26.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7707 17.342C30.4544 17.1185 30.0811 16.9993 29.6992 17H27.3034C26.2449 17 25.3867 17.8955 25.3867 19V21.5C25.3867 22.6046 26.2449 23.5 27.3034 23.5H29.6992C30.7578 23.5 31.6159 22.6046 31.6159 21.5V19C31.6158 18.3351 31.299 17.7137 30.7707 17.342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.671 17.882C39.3148 17.3307 38.7192 17.0001 38.082 17H35.6862C34.6277 17 33.7695 17.8955 33.7695 19V21.5C33.7695 22.6046 34.6277 23.5 35.6862 23.5H38.082C39.1406 23.5 39.9987 22.6046 39.9987 21.5V19C39.9993 18.6015 39.8852 18.212 39.671 17.882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9167 34.5H21.3125C22.371 34.5 23.2292 35.3954 23.2292 36.5V39C23.2292 40.1046 22.371 41 21.3125 41H18.9167C17.8581 41 17 40.1046 17 39V36.5C17 35.3955 17.8581 34.5 18.9167 34.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1535 34.842C38.8373 34.6185 38.464 34.4993 38.082 34.5H35.6862C34.6277 34.5 33.7695 35.3954 33.7695 36.5V39C33.7695 40.1046 34.6277 41 35.6862 41H38.082C39.1406 41 39.9987 40.1046 39.9987 39V36.5C39.9986 35.8351 39.6818 35.2137 39.1535 34.842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9167 25.75H21.3125C22.371 25.75 23.2292 26.6455 23.2292 27.75V30.25C23.2292 31.3546 22.371 32.25 21.3125 32.25H18.9167C17.8581 32.25 17 31.3546 17 30.25V27.75C17 26.6454 17.8581 25.75 18.9167 25.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1535 26.092C38.8373 25.8685 38.464 25.7493 38.082 25.75H35.6862C34.6277 25.75 33.7695 26.6455 33.7695 27.75V30.25C33.7695 31.3546 34.6277 32.25 35.6862 32.25H38.082C39.1406 32.25 39.9987 31.3546 39.9987 30.25V27.75C39.9986 27.085 39.6818 26.4637 39.1535 26.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9167 17H21.3125C22.371 17 23.2292 17.8955 23.2292 19V21.5C23.2292 22.6046 22.371 23.5 21.3125 23.5H18.9167C17.8581 23.5 17 22.6046 17 21.5V19C17 17.8955 17.8581 17 18.9167 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7707 34.842C30.4544 34.6185 30.0811 34.4993 29.6992 34.5H27.3034C26.2449 34.5 25.3867 35.3954 25.3867 36.5V39C25.3867 40.1046 26.2449 41 27.3034 41H29.6992C30.7578 41 31.6159 40.1046 31.6159 39V36.5C31.6158 35.8351 31.299 35.2137 30.7707 34.842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7707 26.092C30.4544 25.8685 30.0811 25.7493 29.6992 25.75H27.3034C26.2449 25.75 25.3867 26.6455 25.3867 27.75V30.25C25.3867 31.3546 26.2449 32.25 27.3034 32.25H29.6992C30.7578 32.25 31.6159 31.3546 31.6159 30.25V27.75C31.6158 27.085 31.299 26.4637 30.7707 26.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7707 17.342C30.4544 17.1185 30.0811 16.9993 29.6992 17H27.3034C26.2449 17 25.3867 17.8955 25.3867 19V21.5C25.3867 22.6046 26.2449 23.5 27.3034 23.5H29.6992C30.7578 23.5 31.6159 22.6046 31.6159 21.5V19C31.6158 18.3351 31.299 17.7137 30.7707 17.342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.671 17.882C39.3148 17.3307 38.7192 17.0001 38.082 17H35.6862C34.6277 17 33.7695 17.8955 33.7695 19V21.5C33.7695 22.6046 34.6277 23.5 35.6862 23.5H38.082C39.1406 23.5 39.9987 22.6046 39.9987 21.5V19C39.9993 18.6015 39.8852 18.212 39.671 17.882Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9826_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribePhotos);
export default __webpack_public_path__ + "static/media/subscribe-photos.6929b86570880a91a433ae8d950044ac.svg";
export { ForwardRef as ReactComponent };